<div class="student-details-intro">
  <span class="more">{{ 'MORE_DETAILS' | ltTranslate }}</span>
  <span class="complete"> {{ 'COMPLETE_AND_CONTINUE' | ltTranslate }}</span>
</div>

<div class="student-details-stepper">
  <div class="student-details-stepper__stepper">
    <div class="student-details-stepper__item">
      <div class="student-details-stepper__dot"></div>
      <div class="student-details-stepper__text">{{ 'INFO_BAR_CART_TEXT' | ltTranslate }}</div>
    </div>
    <div class="student-details-stepper__item">
      <div class="student-details-stepper__dot student-details-stepper__dot--active"></div>
      <div class="student-details-stepper__text">{{ 'STUDENT_DETAILS' | ltTranslate }}</div>
    </div>
    <div class="student-details-stepper__item">
      <div class="student-details-stepper__dot"></div>
      <div class="student-details-stepper__text">{{ 'BILLING_INFO_TITLE' | ltTranslate }}</div>
    </div>
  </div>
</div>

<div class="student-details">
  <div class="student-details__heading">
    {{ headingKey() | ltTranslate: headingParams() }}
  </div>

  <div class="student-details__banner">
    <span class="student-details__banner-label">{{ 'MY_DASHBOARD_SHOPPING_FOR' | ltTranslate }}:</span>
    <div class="student-details__banner-item season">
      <lt-icon class="calendar" name="fa-regular-calendar"></lt-icon>
      <span class="season-name">{{ currentEventNameAndYear() }}</span>
    </div>
    <div class="student-details__banner-item">
      <lt-icon name="fa-regular-graduation-cap"></lt-icon>
      <span class="school-name should-stay-masked">{{ currentAccountName() }}</span>
    </div>
  </div>

  <div class="student-details__form">
    <div class="student-details__row">
      <div class="student-details__field-group">
        <div class="student-details__field-grow should-stay-masked">
          <lt-text-input
            testId="student-details-first-name-input"
            [label]="'STUDENT_FULL_FIRST_NAME_LABEL' | ltTranslate"
            [value]="firstName()"
            [maxlength]="subjectNameMaxLength"
            [error]="firstNameErrorMessage() ? (firstNameErrorMessage() | ltTranslate) : null"
            (valueChange)="onFirstNameChange($event)"
          />
        </div>
        <lt-uib-popover
          [popoverTrigger]="'click'"
          [popoverPlacement]="'auto'"
          [popoverClass]="'popover-dark'"
          [uibPopover]="'STUDENT_FIRST_NAME_PROMPT' | ltTranslate"
        >
          <lt-icon name="fa-sharp-regular-info-circle" class="student-details__info-icon cursor-pointer" />
        </lt-uib-popover>
      </div>

      @if (showPreferredFirstName()) {
        <div class="student-details__field-group student-details__field-group--preferred">
          <div class="student-details__field-grow should-stay-masked">
            <lt-text-input
              testId="student-details-preferred-first-name-input"
              [label]="'STUDENT_PREFERRED_FIRST_NAME_LABEL' | ltTranslate"
              [value]="preferredFirstName()"
              [maxlength]="preferredFirstNameMaxLength()"
              [error]="preferredFirstNameErrorMessage() ? (preferredFirstNameErrorMessage() | ltTranslate) : null"
              (valueChange)="onPreferredFirstNameChange($event)"
            />
          </div>
          <div class="student-details__tooltip-anchor">
            <lt-uib-popover
              [popoverTrigger]="'click'"
              [popoverPlacement]="'auto'"
              [popoverClass]="'popover-dark student-details-preferred-name-popover'"
              [uibPopoverHtml]="'STUDENT_PREFERRED_FIRST_NAME_TOOLTIP' | ltTranslate"
            >
              <lt-icon
                data-testid="student-details-preferred-name-info-icon"
                name="fa-sharp-regular-info-circle"
                class="student-details__info-icon cursor-pointer"
              />
            </lt-uib-popover>
          </div>
        </div>
      } @else {
        <div class="student-details__field-grow should-stay-masked">
          <lt-text-input
            testId="student-details-last-name-input"
            [label]="'STUDENT_FULL_LAST_NAME_LABEL' | ltTranslate"
            [value]="lastName()"
            [maxlength]="subjectNameMaxLength"
            [error]="lastNameErrorMessage() ? (lastNameErrorMessage() | ltTranslate) : null"
            (valueChange)="onLastNameChange($event)"
          />
        </div>
      }
    </div>

    @if (showPreferredFirstName()) {
      <div class="student-details__row student-details__row--full-width">
        <div class="student-details__field-grow should-stay-masked">
          <lt-text-input
            testId="student-details-last-name-input"
            [label]="'STUDENT_FULL_LAST_NAME_LABEL' | ltTranslate"
            [value]="lastName()"
            [maxlength]="subjectNameMaxLength"
            [error]="lastNameErrorMessage() ? (lastNameErrorMessage() | ltTranslate) : null"
            (valueChange)="onLastNameChange($event)"
          />
        </div>
      </div>
    }

    @if (isClassRoomGroup()) {
      <div class="student-details__row teacher-info should-stay-masked">
        <lt-text-input
          testId="student-details-teacher-last-name-input"
          [label]="'TEACHER_LAST_NAME' | ltTranslate"
          [value]="teacherLastName()"
          [maxlength]="teacherNameMaxLength"
          [error]="teacherLastNameErrorMessage() ? (teacherLastNameErrorMessage() | ltTranslate) : null"
          (valueChange)="onTeacherLastNameChange($event)"
        />
      </div>
    }

    <div class="student-details__row">
      <lt-select
        testId="student-details-grade-select"
        [label]="'STUDENT_CURRENT_GRADE_LABEL' | ltTranslate"
        [value]="grade()"
        [options]="gradeOptions"
        (valueChange)="grade.set($event)"
      />

      <lt-select
        testId="student-details-relationship-select"
        [label]="'RELATIONSHIP' | ltTranslate"
        [value]="relationship()"
        [options]="relationshipOptions"
        (valueChange)="relationship.set($event)"
      />
    </div>

    @if (relationship()) {
      <div class="student-details__disclaimer">
        <label for="student-details-disclaimer-checkbox" class="student-details__disclaimer-label">
          <input
            type="checkbox"
            id="student-details-disclaimer-checkbox"
            class="student-details__disclaimer-checkbox"
            data-testid="student-details-disclaimer-checkbox"
            [checked]="disclaimerAccepted()"
            (change)="disclaimerAccepted.set($any($event.target).checked)"
          />
          <span
            class="student-details__disclaimer-box"
            [class.student-details__disclaimer-box--checked]="disclaimerAccepted()"
          >
            @if (disclaimerAccepted()) {
              <lt-icon
                name="fa-sharp-solid-check"
                class="student-details__disclaimer-check"
                aria-hidden="true"
              ></lt-icon>
            }
          </span>
        </label>
        <span class="student-details__disclaimer-text">
          {{ relationshipDisclaimerKey() | ltTranslate }}
        </span>
      </div>
    }
  </div>

  <div class="student-details__actions">
    @if (currentSubjectIndex() > 0) {
      <button class="student-details__back-btn" data-testid="student-details-back-btn" (click)="onGoBack()">
        <lt-icon name="fa-sharp-solid-arrow-left" />
        <span>{{ 'BACK_TO_STUDENT' | ltTranslate: backStudentLabelParams() }}</span>
      </button>
    }
    <lt-button
      testId="student-details-save-continue-btn"
      [class.disabled]="isSaveDisabled()"
      [disabled]="isSaveDisabled()"
      (click)="onSaveAndContinue()"
    >
      {{ buttonLabelKey() | ltTranslate }}
    </lt-button>
  </div>
</div>
